export const enAgentTranslations = {
  agent: {
    // Page titles
    title: "AI Assistant Configuration",
    subtitle: "Configure your AI assistant behavior and personality",
    unsavedChanges: "Unsaved Changes",
    agentName : "Agent Name",
    agentNamePlaceholder : "Enter your agent's name",
    // Agent Status
    agentStatus: "Agent Status",
    agentActive: "Your AI assistant is active and ready to help customers",
    agentInactive: "Your AI assistant is currently disabled",
    active: "Active",
    inactive: "Inactive",
    status: "Status",

    // Predefined Profiles
    predefinedProfiles: "Predefined Profiles",
    predefinedProfilesDesc:
      "Choose from pre-configured agent personalities and styles",

    profiles: {
      lebaneseCasual: {
        name: "Lebanese Casual",
        description: "Friendly Lebanese dialect with conversational style",
      },
      professionalEnglish: {
        name: "Professional English",
        description: "Professional tone with consultative approach",
      },
      quickService: {
        name: "Quick Service",
        description: "Energetic and fast-paced service style",
      },
      chefExpert: {
        name: "Chef Expert",
        description: "Warm and educational culinary expertise",
      },
    },

    // Tone Options
    tones: {
      friendly: {
        label: "Friendly",
        description: "Warm and welcoming approach",
      },
      professional: {
        label: "Professional",
        description: "Formal and courteous",
      },
      casual: {
        label: "Casual",
        description: "Relaxed and informal",
      },
      humorous: {
        label: "Humorous",
        description: "Light-hearted with jokes",
      },
      warm: {
        label: "Warm",
        description: "Caring and personal",
      },
      energetic: {
        label: "Energetic",
        description: "Enthusiastic and lively",
      },
    },

    // Language Options
    languages: {
      multilingual: {
        label: "Multilingual",
        description: "Adapt with the User's Language",
      },
      lebaneseArabish: {
        label: "Lebanese Arabish",
        description: "Mix of Arabic and English",
      },
      english: {
        label: "English",
        description: "Pure English language",
      },
      french: {
        label: "French",
        description: "French language",
      },
      arabic: {
        label: "Arabic",
        description: "Classical Arabic",
      },
      mixed: {
        label: "Mixed",
        description: "Mix languages in the Response",
      },
    },

    // Identity Options
    identities: {
      diningAssistant: {
        label: "Dining Assistant",
        description: "Helps with menu navigation and ordering",
      },
      chefConsultant: {
        label: "Chef Consultant",
        description: "Provides cooking insights and recommendations",
      },
      foodConnoisseur: {
        label: "Food Connoisseur",
        description: "Expert knowledge about cuisine and flavors",
      },
      friendlyWaiter: {
        label: "Friendly Waiter",
        description: "Personal service like a restaurant waiter",
      },
      nutritionGuide: {
        label: "Nutrition Guide",
        description: "Focuses on healthy choices and dietary needs",
      },
    },

    // Response Length Options
    responseLengths: {
      short: {
        label: "Short",
        description: "Brief and concise responses",
      },
      medium: {
        label: "Medium",
        description: "Balanced detail level",
      },
      long: {
        label: "Long",
        description: "Detailed and comprehensive",
      },
    },

    // Helping Strategy Options
    strategies: {
      conversational: {
        label: "Conversational",
        description: "Engages in natural dialogue",
      },
      direct: {
        label: "Direct",
        description: "Straight to the point answers",
      },
      consultative: {
        label: "Consultative",
        description: "Asks questions to understand needs",
      },
      educational: {
        label: "Educational",
        description: "Explains details and provides learning",
      },
      quickService: {
        label: "Quick Service",
        description: "Fast and efficient responses",
      },
    },

    // Configuration sections
    basicConfiguration: "Basic Configuration",
    basicConfigurationDesc: "Core personality and communication settings",
    responseConfiguration: "Response Configuration",
    responseConfigurationDesc: "Control how your agent responds to customers",
    behaviorSettings: "Behavior Settings",
    behaviorSettingsDesc: "Fine-tune specific behaviors and features",

    // Form fields
    tone: "Tone",
    selectTone: "Select tone",
    language: "Language",
    selectLanguage: "Select language",
    identity: "Identity",
    selectIdentity: "Select identity",
    helpingStrategy: "Helping Strategy",
    selectStrategy: "Select strategy",
    strategy: "Strategy",
    responseLength: "Response Length",

    // Behavior toggles
    includeFoodSafety: "Include Food Safety",
    includeFoodSafetyDesc: "Mention allergens and dietary considerations",
    mentionFeaturedItems: "Mention Featured Items",
    mentionFeaturedItemsDesc: "Highlight special dishes and promotions",
    useHumor: "Use Humor",
    useHumorDesc: "Add friendly jokes and light conversation",
    enableOrdering: "Enable Ordering via Assistant",
    enableOrderingDesc: "Allow customers to place orders through the AI assistant",

    // Preview section
    configurationPreview: "Configuration Preview",
    currentSettings: "Current Settings",
    sampleResponse: "Sample Response",
    sampleResponseContent:
      "A {{tone}} {{identity}} would respond in a warm and helpful manner to customer inquiries.",

    // Tips section
    tips: "Tips & Best Practices",
    tip1Title: "Match Your Brand",
    tip1Description:
      "Choose settings that align with your restaurant's personality and service style.",
    tip2Title: "Test Different Profiles",
    tip2Description:
      "Try the predefined profiles first, then customize to find what works best.",
    tip3Title: "Regular Updates",
    tip3Description:
      "Adjust settings based on customer feedback and seasonal changes.",

    // Error messages
    errors: {
      fetchFailed: "Failed to load agent configuration",
      saveFailed: "Failed to save agent configuration",
    },
  },
};
